import {
  CustomButton,
  CustomImage,
  CustomModal,
  errorDialog,
  successDialog,
  Text,
} from '@src/components';
import modalClose from '@src/assets/icons/icon-close.svg';
import React, { useCallback, useEffect, useState } from 'react';
import { Radio, Tooltip, Form } from 'antd';
import '@src/styles/manageMyCards/blockedModal.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
  cardsCancelList,
  processTypesGetPagedList,
  cardActivate,
  cardGetPagedList,
  employeesUpdateList,
  cancelRequestsDelete,
} from '@src/store/slice/manageMyCardsSlice';
import DigitalCardIncentive from '../cardOrders/cardInformation/DigitalCardIncentive';
import { blockedTypeList } from '@src/store/enums';
import PropTypes from 'prop-types';
import iconWhiteInfo from '@src/assets/icons/icn-bilgi-white.svg';
import iconInfo from '@src/assets/icons/icn-bilgi.svg';
import { warningDialog } from '@src/components/CustomDialog';
import CustomInput from '@src/components/CustomInput';
import { useLanguageChange } from '@src/hooks/useLanguageChange';

const BlockedModal = ({
  modalVisible,
  handleModalVisible,
  isCompliments = false,
  isMarket = false,
  blockedModal2Visible = false,
}) => {
  const [selectedValue, setSelectedValue] = useState(undefined);
  const [processTypes, setProcessTypes] = useState([]);
  const [digitalModalVisible, setDigitalModalVisible] = useState(false);
  const [isModalClosed, setIsModalClosed] = useState(true);
  const dispatch = useDispatch();
  const { selectedCards, filterObject } = useSelector((state) => state?.manageMyCards);
  const isComlimentsOrMarket = isCompliments || isMarket;

  const [form] = Form.useForm();

  // The block/cancel reasons are rendered with the backend's own text and are only requested when
  // the modal opens, so an open modal has to ask for them again after a language switch.
  useLanguageChange(async () => {
    if (!modalVisible) return;
    const action = await dispatch(processTypesGetPagedList());
    if (processTypesGetPagedList.fulfilled.match(action)) {
      setProcessTypes(action.payload.data.items);
    }
  });

  useEffect(() => {
    if (modalVisible) {
      (async () => {
        const action = await dispatch(processTypesGetPagedList());
        if (processTypesGetPagedList.fulfilled.match(action)) {
          setProcessTypes(action.payload.data.items);
        } else {
          errorDialog({
            title: <Text t="error" />,
            message: action?.payload?.error?.message,
            onOk: () => {
              handleModalVisible();
            },
          });
        }
      })();
    }
  }, [dispatch, handleModalVisible, modalVisible]);

  useEffect(() => {
    if (!isModalClosed) {
      updateBlockedCardType(9);
    }
  }, [isModalClosed]);

  useEffect(() => {
    if (modalVisible) {
      setSelectedValue(undefined);
      try {
        form.resetFields();
      } catch (error) {
        console.error(error);
      }
    }
  }, [modalVisible]);

  const handleClose = useCallback(() => {
    handleModalVisible(false);
    setSelectedValue(undefined);
  }, [handleModalVisible]);

  const isComplimentsSuccessDialog = () => {
    warningDialog({
      title: '',
      width: 400,
      headerTransparent: true,
      notWarnIcon: true,
      htmlContent: (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <span className="comp-warn-head ">
            <Text t="yourRequestHasBeenReceived" />
          </span>
          <p className="comp-warn-text">
            <Text t="yourTransactionHasBeenSuccessfullyApproved" />
          </p>
          <button
            style={{ marginTop: 20 }}
            className="utts-ok-button comp-warn-confirm"
            onClick={async () => null}
          >
            <Text t="okBtn" />
          </button>
        </div>
      ),
      className: 'warningModal-utts not-show-warning-buttons',
      okButtonProps: 'not-show-warning-buttons',
      onOk: async () => { },
      onCancel: async () => { },
    });
  };

  const isComplimentsShowWarningDialog = (htmlContent, nonPadding = false) => {
    warningDialog({
      title: '',
      width: 550,
      headerTransparent: true,
      notWarnIcon: true,
      htmlContent: htmlContent,
      nonPadding: nonPadding,
      className: 'warningModal-utts not-show-warning-buttons',
      okButtonProps: 'not-show-warning-buttons',
      onOk: async () => { },
      onCancel: async () => { },
    });
  };

  const clickConfirmComplimentsModal = async (selectedValue, tempSelectedCards) => {
    const action = await dispatch(
      cardsCancelList({ id: selectedValue, selectedCards: tempSelectedCards }),
    );
    if (cardsCancelList.fulfilled.match(action)) {
      await dispatch(cardGetPagedList({ ...filterObject }));
      isComplimentsSuccessDialog();
    }
  };

  const htmlContentSelectedValue1 = (selectedValue, tempSelectedCards) => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span className="comp-warn-head ">
          <Text t="youAreAboutToTemporarilyBlockTheCard" />
        </span>
        <p className="comp-warn-text">
          <Text t="whenYouApproveThisTransactionTheCardWill" />
        </p>{' '}
        <p className="comp-warn-text" style={{ paddingLeft: 30, paddingRight: 30 }}>
          {'"'}
          <a
            href="https://ticketonline.edenred.com.tr/ticket-gift/manage-my-cards"
            style={{ color: '#006cfa', textDecoration: 'underline' }}
            target="_blank"
          >
            <Text t="cardManagement" />
          </a>
          {'" '}
          <Text t="youCanAccessYourTemporarilyBlockedCardsAnd" />
        </p>
        <button
          style={{ marginTop: 20 }}
          className="utts-ok-button comp-warn-confirm"
          onClick={async () => clickConfirmComplimentsModal(selectedValue, tempSelectedCards)}
        >
          <Text t="approve2" />
        </button>
        <button
          className="utts-cancel-button gift-cancel-order-cancel"
          onClick={() => handleClose()}
        >
          <Text t="giveUp" />
        </button>
      </div>
    );
  };

  const htmlContentSelectedValue2 = (selectedValue, tempSelectedCards) => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span className="comp-warn-head ">
          <Text t="youAreAboutToCompletelyCancelTheCard" />
        </span>
        <p className="comp-warn-text">
          <Text t="whenYouApproveThisTransactionTheCardWill3" />
        </p>
        <button
          style={{ marginTop: 20 }}
          className="utts-ok-button comp-warn-confirm"
          onClick={async () => clickConfirmComplimentsModal(selectedValue, tempSelectedCards)}
        >
          <Text t="approve2" />
        </button>
        <button
          className="utts-cancel-button gift-cancel-order-cancel"
          onClick={() => handleClose()}
        >
          <Text t="giveUp" />
        </button>
      </div>
    );
  };

  const htmlContentSelectedValue4 = (selectedValue, tempSelectedCards) => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span className="comp-warn-head ">
          <Text t="youAreAboutToRemoveTheCardFrom" />
        </span>
        <p className="comp-warn-text">
          <Text t="whenYouApproveThisTransactionTheCardWill2" />
        </p>
        <button
          style={{ marginTop: 20 }}
          className="utts-ok-button comp-warn-confirm"
          onClick={async () => clickConfirmComplimentsModal(selectedValue, tempSelectedCards)}
        >
          <Text t="approve2" />
        </button>
        <button
          className="utts-cancel-button gift-cancel-order-cancel"
          onClick={() => handleClose()}
        >
          <Text t="giveUp" />
        </button>
      </div>
    );
  };

  const htmlContentSelectedValue3 = (selectedValue, tempSelectedCards) => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span className="comp-warn-head" style={{ marginBottom: 5 }}>
          <Text t="cancelExistingCardAndNew" />
        </span>
        <span className="comp-warn-head">
          <Text t="youAreAboutToCreateAPhysicalCard" />
        </span>
        <p className="comp-warn-text" style={{ paddingLeft: 15, paddingRight: 15 }}>
          <Text t="whenYouApproveThisTransactionTheCurrentCard" />
        </p>
        <button
          style={{ marginTop: 20 }}
          className="utts-ok-button comp-warn-confirm"
          onClick={async () => clickConfirmComplimentsModal(selectedValue, tempSelectedCards)}
        >
          <Text t="approve2" />
        </button>
        <button
          className="utts-cancel-button gift-cancel-order-cancel"
          onClick={() => handleClose()}
        >
          <Text t="giveUp" />
        </button>
      </div>
    );
  };

  const normalizePhone = (value) => {
    // Başta zaten +90 varsa dokunma
    if (value.startsWith('+90')) return value;
    // Sıfır ile başlıyorsa onu kaldır
    const digitsOnly = value.replace(/[^\d]/g, '').replace(/^0+/, '');
    return '+90' + digitsOnly;
  };

  const htmlContentDijitalCardPhone = (selectedValue, tempSelectedCards) => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span
          className="comp-warn-head"
          style={{ paddingLeft: 24, paddingRight: 24, textAlign: 'left' }}
        >
          <Text t="pleaseEnterACurrentPhoneNumber" />
        </span>
        <p
          className="comp-warn-text"
          style={{ paddingLeft: 24, paddingRight: 24, textAlign: 'left' }}
        >
          <Text t="yourNewDigitalCardNumberWillBeSent" />
        </p>
        <Form
          form={form}
          onFinish={(values) => {
            if (values?.phone)
              handleUpdate(tempSelectedCards[0], selectedValue, tempSelectedCards, values?.phone);
          }}
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
          layout="vertical"
        >
          <div
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#f2f5f7',
              display: 'flex',
              width: '100%',
              paddingTop: 24,
            }}
          >
            <Form.Item
              label=""
              name="phone"
              normalize={normalizePhone}
              rules={[
                { required: true, message: 'Lütfen telefon numarası girin!' },
                {
                  pattern: /^\+?\d{10,14}$/,
                  message: 'Geçerli bir telefon numarası girin',
                },
              ]}
            >
              <CustomInput
                id="companyInformation-creditCards-newCreditCard-creditCardForm-cvv-input"
                placeholder={'+90 (___) ___ __ __'}
                maxLength={13}
                style={{ width: 300, borderColor: '#cbd5e1', borderRadius: 12, borderWidth: 2 }}
              />
            </Form.Item>
          </div>
          <button
            style={{ marginTop: 20 }}
            className="utts-ok-button comp-warn-confirm"
            type="submit"
          >
            <Text t="updateBtn" />
          </button>
        </Form>
      </div>
    );
  };

  const handleUpdate = async (record, selectedValue, tempSelectedCards, phone) => {
    try {
      let body = {
        customerId: record?.customerId,
        vouId: 94,
        requestDto: {
          personalCode: record?.personalCode,
          cardNumber: record?.cardNumber,
          gsm: phone
            ?.replace('+90', '')
            ?.replace(/\)/g, '')
            ?.replace(/\(/g, '')
            ?.replace(/-/g, '')
            ?.replace(/ /g, ''),
          isAddressUpdate: false,
          refNo: record?.refNo,
        },
        mobilePaymentUpdateRequestDto: {
          customerId: record?.customerId,
          vouId: 94,
          cardNumber: record?.cardNumber,
        },
      };

      if (!record.cardType) {
        body.mobilePaymentUpdateRequestDto.mobileAppUserId = null;
      }

      if (record?.mobileAppUserId) {
        body.mobilePaymentUpdateRequestDto.mobileAppUserId = record?.mobileAppUserId;
      }

      const action = await dispatch(employeesUpdateList(body));
      if (employeesUpdateList.fulfilled.match(action)) {
        clickConfirmComplimentsModal(selectedValue, tempSelectedCards);
      }
    } catch (error) { }
  };

  const htmlContentSelectedValue9 = (selectedValue, tempSelectedCards) => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span className="comp-warn-head ">
          <Text t="youAreAboutToCancelExistingCardAnd" />
        </span>
        <p className="comp-warn-text" style={{ marginBottom: 0 }}>
          <Text t="whenYouApproveThisTransactionTheCurrentCard2" />
        </p>
        <p className="comp-warn-text" style={{ marginBottom: 0 }}>
          <Text t="numberWillBeCreatedAndSentToThe" />
        </p>
        <p className="comp-warn-text">
          <Text t="willBeSentViaSmsToTheMobile" />
        </p>
        <button
          style={{ marginTop: 20 }}
          className="utts-ok-button comp-warn-confirm"
          onClick={async () => {
            if (
              tempSelectedCards?.filter(
                (tSC) => tSC.gsm !== null && tSC.gsm !== undefined && tSC.gsm !== '',
              ).length === 0
            ) {
              isComplimentsShowWarningDialog(
                htmlContentDijitalCardPhone(selectedValue, tempSelectedCards),
                true,
              );
            } else {
              clickConfirmComplimentsModal(selectedValue, tempSelectedCards);
            }
          }}
        >
          <Text t="approve2" />
        </button>
        <button
          className="utts-cancel-button gift-cancel-order-cancel"
          onClick={() => handleClose()}
        >
          <Text t="giveUp" />
        </button>
      </div>
    );
  };

  const htmlContentSelectedValue6 = (selectedValue, tempSelectedCards) => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span className="comp-warn-head ">
          <Text t="youAreAboutToOpenTheCardFor" />
        </span>
        <p className="comp-warn-text" style={{ marginBottom: 0 }}>
          <Text t="whenYouApproveThisTransactionTheTemporarilyBlocked" />
        </p>
        <p className="comp-warn-text" style={{ marginBottom: 0 }}>
          <Text t="willBeReopenedForUseAndBecomeActive" />
        </p>
        <p className="comp-warn-text">
          <Text t="willCome" />
        </p>
        <button
          style={{ marginTop: 20 }}
          className="utts-ok-button comp-warn-confirm"
          onClick={async () => {
            const action = await dispatch(cardActivate(tempSelectedCards[0].cardNumber));
            if (cardActivate.fulfilled.match(action)) {
              isComplimentsSuccessDialog();
              await dispatch(cardGetPagedList({ ...filterObject }));
            }
          }}
        >
          <Text t="approve2" />
        </button>
        <button
          className="utts-cancel-button gift-cancel-order-cancel"
          onClick={() => handleClose()}
        >
          <Text t="giveUp" />
        </button>
      </div>
    );
  };

  const showComplimentsDialogByValue = (value, cards) => {
    const dialogMap = {
      1: htmlContentSelectedValue1,
      2: htmlContentSelectedValue2,
      3: htmlContentSelectedValue3,
      4: htmlContentSelectedValue4,
      6: htmlContentSelectedValue6,
      9: htmlContentSelectedValue9,
    };

    const dialogFn = dialogMap[value];
    if (dialogFn) {
      isComplimentsShowWarningDialog(dialogFn(value, cards));
    }
  };

  const handleCardActivation = async (cardNumber, successText) => {
    const action = await dispatch(cardActivate(cardNumber));
    if (cardActivate.fulfilled.match(action)) {
      await dispatch(cardGetPagedList({ ...filterObject }));
      successDialog({
        title: <Text t="successfullySent" />,
        message: action?.payload?.data || successText,
        onOk: handleClose,
      });
    }
  };

  const handleCardCancel = async (value) => {
    const action = await dispatch(cardsCancelList({ id: value }));
    if (!cardsCancelList.fulfilled.match(action)) return;

    await dispatch(cardGetPagedList({ ...filterObject }));

    const matchedType = blockedTypeList.find((t) => t.selected === value) || blockedTypeList[2];

    successDialog({
      title: <Text t="successfullySent" />,
      message: action?.payload?.data || matchedType.text,
      onOk: handleClose,
    });
  };

  const handleApprove = useCallback(async () => {
    if (!selectedValue) return;

    // Compliments / Market flow
    if (isComlimentsOrMarket && selectedCards) {
      handleModalVisible(false);
      showComplimentsDialogByValue(selectedValue, selectedCards);
      return;
    }

    if (selectedValue === blockedTypeList[2].selected) {
      await handleCardActivation(selectedCards[0].cardNumber, blockedTypeList[2].text);
      return;
    }

    await handleCardCancel(selectedValue);
  }, [dispatch, handleClose, selectedValue, selectedCards]);

  const onChange = useCallback((e) => {
    if (e?.target?.value === 3 && !(isCompliments || isMarket)) {
      setDigitalModalVisible(true);
    }
    setSelectedValue(e.target.value);
  }, []);

  const updateBlockedCardType = async (type) => {
    setSelectedValue(type);
    setIsModalClosed(true);
  };

  const getModalItemRender = (id) => {
    switch (id) {
      case 1:
        return (
          <span className="comp-text-style-1">
            <Text t="youCanReactivateTheCardThatWasTemporarily" />
          </span>
        );
      case 9:
        return (
          <span className="comp-text-style-1">
            <Text t="cardWillBeCancelledAndNewDigitalCard" />{' '}
            <b>
              <Text t="viaSmsToTheCurrentCardUser" />
            </b>{' '}
            <Text t="willBeTransmitted" />
          </span>
        );
      case 3:
        return (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span className="comp-text-style-1">
              <Text t="cardWillBeCancelledAndNewPhysicalCard" />{' '}
              <b>
                <Text t="withTheInformationOfTheCurrentCardUser" />
              </b>{' '}
              <Text t="willBeProduced" />
            </span>
            <Text t="theEstimatedDeliveryTimeOfTheCardIs" />
          </div>
        );
      case 2:
        return (
          <span className="comp-text-style-1">
            <Text t="cardWillBeCompletelyCancelledAndClosedFor" />
          </span>
        );
      case 6:
        return (
          <span className="comp-text-style-1">
            <Text t="youCanReopenTheTemporarilyBlockedCardAnd" />
          </span>
        );
      default:
        return (
          <span className="comp-text-style-1">
            <Text t="cardWillRemainOpenForUseButWill" />
          </span>
        );
    }
  };

  return (
    <>
      <CustomModal
        className={isCompliments || isMarket ? 'comp-blocked-modal' : 'blocked-modal'}
        maskClosable={false}
        footer={false}
        width={590}
        title={<Text t={isCompliments || isMarket ? 'transactions' : 'blockedProgress'} />}
        visible={modalVisible}
        onCancel={handleClose}
        closeIcon={<CustomImage src={modalClose} />}
      >
        <Radio.Group
          id="ticketRestaurant-manageMyCards-blockedModal-custom-radioGroup-input-content"
          onChange={onChange}
          value={selectedValue}
          className="custom-radio-input-content"
        >
          {processTypes
            ?.filter((item) =>
              blockedModal2Visible ? item.id !== 9 && item.id !== 3 : !blockedModal2Visible,
            )
            .map((item, index) => {
              return (
                <Radio
                  id={`ticketRestaurant-manageMyCards-blockedModal-${item?.id}-${item?.name}-radio`}
                  value={item?.id}
                  className="custom-radio-input"
                  key={`${item?.id}-${item?.name}`}
                >
                  <div dangerouslySetInnerHTML={{ __html: item?.name }} />
                  {isCompliments || isMarket ? (
                    <Tooltip
                      overlayClassName={
                        item.id === 3
                          ? 'compliment-blocked-custom-tooltip-long'
                          : 'compliment-blocked-custom-tooltip'
                      }
                      title={
                        <div className="div-box">
                          <CustomImage src={iconWhiteInfo} />
                          {getModalItemRender(item.id)}
                        </div>
                      }
                      color="#646363"
                      placement="bottomRight"
                      arrowPointAtCenter={true}
                    >
                      {''}
                      <CustomImage src={iconInfo} style={{ marginLeft: 10 }} />
                    </Tooltip>
                  ) : null}
                </Radio>
              );
            })}
        </Radio.Group>

        {isCompliments || isMarket ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: 20,
            }}
          >
            <button
              onClick={handleApprove}
              style={{
                width: 121,
                color: '#fff',
                height: 46,
                backgroundColor: '#162056',
                borderWidth: 0,
                borderRadius: 6,
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                fontSize: 16,
                marginBottom: 20,
              }}
            >
              <Text t="continue2" />
            </button>
            <button
              onClick={handleClose}
              style={{
                width: 121,
                color: '#1e293b',
                height: 46,
                backgroundColor: 'transparent',
                textDecoration: 'underline',
                borderWidth: 0,
                borderRadius: 6,
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                fontSize: 16,
              }}
            >
              <Text t="giveUp" />
            </button>
          </div>
        ) : (
          <div className="footer-btn">
            <CustomButton
              id="ticketRestaurant-manageMyCards-blockedModal-download-btn"
              className="download-btn"
              onClick={handleApprove}
            >
              <Text t="approve2" />
            </CustomButton>
            <CustomButton
              id="ticketRestaurant-manageMyCards-blockedModal-cancel-btn"
              className="cancel-btn"
              onClick={handleClose}
            >
              <Text t="giveUp" />
            </CustomButton>
          </div>
        )}
      </CustomModal>
      <DigitalCardIncentive
        digitalModalVisible={digitalModalVisible}
        setDigitalModalVisible={setDigitalModalVisible}
        isModalClosed={isModalClosed}
        setIsModalClosed={setIsModalClosed}
      />
    </>
  );
};

BlockedModal.propTypes = {
  modalVisible: PropTypes.any,
  handleModalVisible: PropTypes.any,
  isCompliments: PropTypes.bool,
  isMarket: PropTypes.bool,
  blockedModal2Visible: PropTypes.bool,
};
export default BlockedModal;
